import { _ as __assign } from '../../chunks/bundle-CxLxJCBu.js';
import React__default from 'react';
import { M as MessageInputWrapperView } from '../../chunks/bundle-CHqSZaW8.js';
export { V as VoiceMessageInputWrapper } from '../../chunks/bundle-CHqSZaW8.js';
import { useGroupChannelContext } from '../context.js';
import '../../chunks/bundle-rjBen5BS.js';
import '../../chunks/bundle-CpMvhj21.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-d1cOX5nv.js';
import '../../chunks/bundle-DS1EhNtb.js';
import './SuggestedMentionList.js';
import '../../chunks/bundle-Dgu8bVmd.js';
import '../../chunks/bundle-CjJk57u5.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-kFa80LJe.js';
import '../../chunks/bundle-DOfhjbKd.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-C_zEpfCP.js';
import '../../chunks/bundle-DKdROCX_.js';
import '../../chunks/bundle-D2GzZ_yy.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/QuoteMessageInput.js';
import '../../chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DiK8ifY3.js';
import '../../chunks/bundle-C-nZYnmy.js';
import '../../chunks/bundle-DP3z2QNm.js';
import '../../chunks/bundle-CTVxl16S.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-DdJ9pMWn.js';
import '../../chunks/bundle-DRpjMk0B.js';
import 'react-dom';
import '../../chunks/bundle-Ci-RNuvu.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '@sendbird/uikit-tools';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-BzR1dD25.js';
import '../../ui/SortByRow.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-DoHO4wpB.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ProgressBar.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-B5157rdG.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-GawAxqNK.js';
import 'dompurify';
import '../../chunks/bundle-B5pWUwTI.js';
import '../../chunks/bundle-CiR8AZTC.js';
import '../../chunks/bundle-Bs4dlPq1.js';
import '../../chunks/bundle-AmtSwuex.js';
import '../../chunks/bundle-B5N-CojP.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-DXFVroy5.js';
import '../../chunks/bundle-BoENnpQQ.js';
import '../../chunks/bundle-B_14cMxa.js';
import '../../chunks/bundle-3sZs8f9n.js';
import '../../chunks/bundle-mqagBpi9.js';
import '../../chunks/bundle-QgerWYLz.js';
import '../../chunks/bundle-BW3AiewC.js';

var MessageInputWrapper = function (props) {
    var context = useGroupChannelContext();
    return React__default.createElement(MessageInputWrapperView, __assign({}, props, context));
};

export { MessageInputWrapper, MessageInputWrapper as default };
//# sourceMappingURL=MessageInputWrapper.js.map
